<template>
  <md-card class="md-card-product" @mouseleave.native="onMouseLeave">
    <md-card-header
      v-if="checkBoolean(cardHeader)"
      @mouseenter.native="onMouseOver"
      :data-header-animation="headerAnimation"
      class="md-card-header-image animated"
    >
      <slot name="imageHeader"></slot>
    </md-card-header>

    <md-card-content>
      <slot name="title"></slot>
      <slot name="date"></slot>
      <slot name="description"></slot>
    </md-card-content>

    <md-card-actions
      v-if="checkBoolean(cardFooter)"
      md-alignment="space-between"
    >
      <slot name="footer"></slot>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: "product-card",
  props: {
    headerAnimation: {
      type: String,
      default: "false"
    },
    cardHeader: {
      type: String,
      default: "true"
    },
    cardFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      imgHovered: false,
      fixedHeader: false
    };
  },
  methods: {
    checkBoolean: function(v) {
      return v.toString() === "true";
    },
    headerBack: function() {
      this.fixedHeader = false;
    },
    onMouseOver: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = true;
      }
    },
    onMouseLeave: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
